<template>
  <li class="relative">
    <PulseVisualizer ref="pulseVisualizer" />
    <UserLabel displayName="Stethoscope">
      <ViceStethoscope class="h-8 w-8 -my-1 mr-2 shadow-filter" />
    </UserLabel>
  </li>
</template>

<script>
import UserLabel from '@/Components/Session/Grid/UserLabel.vue';
import ViceStethoscope from '@/Components/Icons/ViceStethoscope.vue';
import PulseVisualizer from '@/Components/Session/PulseVisualizer.vue';

export default {
  props: ['pulseVisualizer'],
  components: {
    UserLabel,
    PulseVisualizer,
    ViceStethoscope,
  },
  setup() {},
};
</script>
